import GetByArticleNumberRequestModelBase from '../_generated/modelBases/get-by-article-number-request-model-base';

export default class GetByArticleNumberRequestModel extends GetByArticleNumberRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
